import React from "react";
import Chart from "react-apexcharts";
import { Box, Card, Typography, Stack } from "@mui/material";

const RiderDashboardSample = ({ riderInfoDetails }) => {

  const riderInfo = riderInfoDetails ?? {};
  const { riderAvailabilityInfo = {} } = riderInfo;

  const {
    onDuty = 0,
    offDuty = 0,
    onVacation = 0,
    onBreak = 0,
    onDutyInfo = {},
  } = riderAvailabilityInfo;
  console.log(onDuty);
  const {
    deliveryBusy = 0,
    busyOnHub = 0,
    freeAtHub = 0,
    deliveredFreed = 0,
    unavailable = 0,
  } = onDutyInfo;

  const chartHeight = 180;

  const availabilityOptions = {
    chart: { type: "donut", toolbar: { show: false } },
    labels: ["On Duty", "Off Duty", "On Vacation"],
    colors: ["#00C49F", "#FFB347", "#0088FE"],
    legend: { show: false },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "Total",
              formatter: () => onDuty + offDuty + onVacation,
            },
          },
        },
      },
    },
  };

  const availabilitySeries = [onDuty, offDuty, onVacation];

  const dutyOptions = {
    chart: { type: "donut", toolbar: { show: false } },
    labels: ["Delivery Busy", "Busy on Hub", "Free at Hub", "Delivered Freed", "Unavailable"],
    colors: ["#FF6961", "#FFA500", "#32CD32", "#9370DB", "#808080"],
    legend: { show: false },
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            total: {
              show: true,
              label: "On-Duty",
              formatter: () =>
                onDuty,
            },
          },
        },
      },
    },
  };

  const dutySeries = [deliveryBusy, busyOnHub, freeAtHub, deliveredFreed, unavailable];

  const legendItems = [
    { label: "On Duty", color: "#00C49F" },
    { label: "Off Duty", color: "#FFB347" },
    { label: "On Vacation", color: "#0088FE" },
    { label: "Delivery Busy", color: "#FF6961" },
    { label: "Busy on Hub", color: "#FFA500" },
    { label: "Free at Hub", color: "#32CD32" },
    { label: "Delivered Freed", color: "#9370DB" },
    { label: "Unavailable", color: "#808080" },
  ];

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Stack
        direction="row"
        spacing={1}
        justifyContent="space-around"
        alignItems="flex-start"
        sx={{ width: '100%' }}
      >
        <Box sx={{ flex: 1, textAlign: "center", minWidth: 0 }}>
          <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1, fontSize: '12px', whiteSpace: 'nowrap' }}>
            Rider Availability
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Chart
              options={availabilityOptions}
              series={availabilitySeries}
              type="donut"
              height={chartHeight}
              width="100%"
            />
          </Box>
        </Box>

        <Box sx={{ flex: 1, textAlign: "center", minWidth: 0 }}>
          <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1, fontSize: '12px', whiteSpace: 'nowrap' }}>
            On-Duty Breakdown
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Chart
              options={dutyOptions}
              series={dutySeries}
              type="donut"
              height={chartHeight}
              width="100%"
            />
          </Box>
        </Box>
      </Stack>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          mt: 3,
          gap: { xs: 1, sm: 2 },
          width: '100%'
        }}
      >
        {legendItems.map((item, index) => (
          <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: { xs: '120px', sm: 'auto' } }}>
            <Box
              sx={{
                width: 12,
                height: 12,
                backgroundColor: item.color,
                borderRadius: "50%",
                flexShrink: 0
              }}
            />
            <Typography variant="body2" sx={{ fontSize: { xs: 11, sm: 13 } }}>{item.label}</Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RiderDashboardSample;
